import {
    MisoPercentageReduction,
    ProjectSizeAdjustmentType
} from "in_queue/types/scenarioType";
import { isProjectExcluded } from "in_queue/types/scenarioUtils";

export const applyWithdrawnDefaults = ({
    assumptions,
    honoredProjectIds,
    withdrawnProjectIds
}: {
    assumptions: Record<string, MisoPercentageReduction>;
    honoredProjectIds: Set<string>;
    withdrawnProjectIds: Set<string>;
}): {
    assumptions: Record<string, MisoPercentageReduction>;
    keptExcludedProjectIds: ReadonlyArray<string>;
    reinstatedProjectIds: ReadonlyArray<string>;
} => {
    const next = { ...assumptions };
    const keptExcludedProjectIds: string[] = [];
    const reinstatedProjectIds: string[] = [];

    withdrawnProjectIds.forEach((projectId) => {
        if (!honoredProjectIds.has(projectId)) {
            next[projectId] = {
                type: ProjectSizeAdjustmentType.PERCENTAGE_REDUCTION,
                eris: 100,
                nris: 100
            };
            keptExcludedProjectIds.push(projectId);
            return;
        }

        if (!isProjectExcluded(next[projectId])) {
            reinstatedProjectIds.push(projectId);
        }
    });

    return { assumptions: next, keptExcludedProjectIds, reinstatedProjectIds };
};
